import RestService from './RestService'

export default class FieldService extends RestService {
  constructor() {
    super('fields')
  }
}